module.exports = __webpack_public_path__ + "static/arizona-1-b50c34ee6e25abc7ee306ed3dea9bbfc.png";